import { type ParsedItem } from '@/features/types/attachments';

// Helper function to build XML attributes from metadata
export const buildXmlAttributes = (item: ParsedItem): string => {
  const attributes: string[] = [];

  // Always include filename
  attributes.push(`filename="${item.filename}"`);

  // Add documentType if present
  if (item.documentType) {
    attributes.push(`type="${item.documentType}"`);
  }

  // Add metadata attributes if present
  if (item.metadata) {
    if (item.metadata.title) attributes.push(`title="${item.metadata.title}"`);
    if (item.metadata.subject) attributes.push(`subject="${item.metadata.subject}"`);
    if (item.metadata.author) attributes.push(`author="${item.metadata.author}"`);
    if (item.metadata.creationDate)
      attributes.push(`creation_date="${item.metadata.creationDate}"`);
    if (item.metadata.modificationDate)
      attributes.push(`modification_date="${item.metadata.modificationDate}"`);
    if (item.metadata.pageCount) attributes.push(`pages="${item.metadata.pageCount}"`);
    if (item.metadata.fileSizeBytes) {
      const sizeMB = (item.metadata.fileSizeBytes / (1024 * 1024)).toFixed(1);
      attributes.push(`size="${sizeMB}MB"`);
    }
  }

  return attributes.join(' ');
};
